import { IconSprite } from "../ui/IconSprite/IconSprite";

import { List, ListObjects, Span } from "./FingerPrintJSValue.styled";

export const FingerPrintJSValue = ({ type, element }) => {
  let content;

  switch (type) {
    case "default":
      content = element;
      break;
    case "icon":
      content = (
        <IconSprite
          tag={element ? "confirm" : "minus"}
          width="32"
          height="32"
        />
      );
      break;
    case "list":
      content = (
        <List>
          {element?.map((child, index) => (
            <li key={index}>{<Span>{child}</Span>}</li>
          ))}
        </List>
      );
      break;
    case "list objects":
      content = (
        <ListObjects>
          {element?.map((child, index) => (
            <li key={index}>
              {
                <p>
                  {child.indicator}: <span>{child.description}</span>
                </p>
              }
            </li>
          ))}
        </ListObjects>
      );
      break;
    case "triangle":
      content = (
        <img
          src={"/assets/images/triangle.png"}
          alt={"triangle"}
          width="300"
          height="132"
        />
      );
      break;
    default:
      content = null;
  }

  return content;
};
